import type { Channel } from "@/utils/fileImport/channels"
import {
  amazon,
  ebay_uk,
  ebay_us,
  etsy,
  shopify,
} from "@/utils/fileImport/channels"

export enum FileChannel {
  amazon_csv = "amazon_csv",
  ebay_uk_csv = "ebay_uk_csv",
  ebay_us_csv = "ebay_us_csv",
  etsy_csv = "etsy_csv",
  shopify_csv = "shopify_csv",
}

export type FileChannelString = keyof typeof FileChannel

export const channelMap: Record<FileChannel, Channel> = {
  [FileChannel.amazon_csv]: amazon.default,
  [FileChannel.ebay_uk_csv]: ebay_uk.default,
  [FileChannel.ebay_us_csv]: ebay_us.default,
  [FileChannel.etsy_csv]: etsy.default,
  [FileChannel.shopify_csv]: shopify.default,
}
export class LocateChannel {
  getChannelBlockConfig(
    channel: FileChannelString,
    fileHeaders: string[],
    blockName: string
  ) {
    const config = this.getChannelConfig(channel)

    if (!Object.hasOwn(config.blockMap, blockName)) {
      throw new Error(`No config found for the Channel: ${channel} and block: ${blockName}`)
    }

    const targetColumn = config.blockMap[blockName].target
    const weightingColumn = config.blockMap[blockName].weightingColumn
    const locatedColumns = config.blockMap[blockName].columns

    const columns: Record<string, number> = {}
    if (locatedColumns) {
      for (const [key, value] of Object.entries(locatedColumns)) {
        columns[key] = this.columnNameToNumber(fileHeaders, value)
      }
    }

    return {
      notInFile: config.blockMap[blockName].notInFile,
      dateFormats: config.dateFormats,
      target: targetColumn ? this.columnNameToNumber(fileHeaders, targetColumn) : undefined,
      weighting: weightingColumn ? this.columnNameToNumber(fileHeaders, weightingColumn) : undefined,
      columns,
    }
  }

  getChannelConfig(channel: FileChannelString) {
    return channelMap[channel]
  }

  identifyChannel(fileHeaders: string[]): FileChannelString | undefined {
    return this.findChannelByHeader(fileHeaders)
  }

  columnNameToNumber(headers: string[], columnName: string) {
    const lowerColumnName = columnName.toLocaleLowerCase()
    return headers.findIndex(
      (column) => column.toLocaleLowerCase() === lowerColumnName
    )
  }

  findChannelByHeader(fileHeaders: string[]): FileChannelString | undefined {
    for (const channel of Object.keys(channelMap)) {
      const headers = channelMap[channel as FileChannel].headers

      for (let i = 0; i < headers.length; i++) {
        const header = headers[i]

        const foundLength = header.filter((h) => fileHeaders.includes(h)).length

        if (header.length === foundLength) {
          return channel as FileChannelString
        }
      }
    }

    return undefined
  }
}
